import CustomButton from '@/components/atoms/CustomButton';
import ModalContainer from '@/components/molecules/ModalContainer/ModalContainer';
import { useToggleActivateLegalDocument } from '@/hooks/legal/legal';
import { LEGAL_DOCUMENT_TYPE_LABELS } from '@/constants/stringVars';
import { TLegalDocument, TLegalDocumentType } from '@/types/Legal.types';
import { Text, VStack } from '@chakra-ui/react';
import React from 'react';

type Props = {
  isOpen: boolean;
  onClose?: () => void;
  document: TLegalDocument;
};

const EulaActivationConfirmModal = ({ isOpen, onClose, document }: Props) => {
  // Refetch (via the hook's cache invalidation) and close, instead of reloading.
  const { isPending, mutate } = useToggleActivateLegalDocument(() => {
    onClose?.();
  });

  const isActive = document.isActive;
  const typeLabel =
    LEGAL_DOCUMENT_TYPE_LABELS[document.type as TLegalDocumentType] ?? document.type?.replaceAll('_', ' ');

  const onConfirm = () => {
    mutate({ isActive, type: document.type, version: document.version });
  };

  return (
    <ModalContainer title="Legal Document Status Update" onClose={onClose} isOpen={isOpen}>
      <VStack spacing={'16px'} alignItems={'flex-start'}>
        <Text>
          {isActive ? 'Deactivate' : 'Activate'} <b>{typeLabel}</b> (version {document.version})?
        </Text>
        {isActive ? (
          <Text fontSize={'14px'} color={'gray.600'}>
            Users will no longer be asked to accept this document. Previously recorded acceptances are kept.
          </Text>
        ) : (
          <Text fontSize={'14px'} color={'gray.600'}>
            This emails affected users, requires them to accept this version, and supersedes the currently active
            version of this type.
          </Text>
        )}
        <CustomButton
          backgroundColor={isActive ? 'red' : 'secondary.500'}
          label={isActive ? 'Deactivate' : 'Activate'}
          onClick={onConfirm}
          isLoading={isPending}
          width={'100%'}
        />
      </VStack>
    </ModalContainer>
  );
};

export default EulaActivationConfirmModal;
